// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// webSocketUrl: 'ws://localhost:8200/tutoraggio/tutoraggiows'

export const environment = {
  production: true,
  local: false,
  hmr: false,
  debugEnabled: false,
  trackUrl: '//analytics.maredigital.it/',
  matomoSiteId: 1,
  assetsPrefixUrl: '/account/assets',
  webSocketUrl: 'wss://selfcaring.marengineering.it/selfcaring/selfcaringws',
  serviceEndpoint: 'https://www.delfi.ai/wp-json',
  wpnonce: 'b77e94c602',
  basicauth: 'ZnJhbmNlc2NvLnNlc3NhOmR0Q0J2Zzk4MU14REQwVW5saUJ4QkVMNw==',
  wpAssistanceFormId: 4820,
  wpReportFormId: 10171,
  isWp: false,
  isInWp: false,
  isRouterEnabled: true,
  wpNoConfig: false,
  wpConfig: {
    serviceEndpoint: 'https://www.delfi.ai/wp-json',
    wpnonce: 'b77e94c602',
    // basicAuth: 'ZnJhbmNlc2NvLnNlc3NhOmR0Q0J2Zzk4MU14REQwVW5saUJ4QkVMNw==' /* ba francesco servicecompany*/
    basicAuth: 'Y2xhdWRpb2F1dHVvcmk6UUhvOWl2cjRWU3FUeVI2UlFrbjNIaG1G' /* ba claudio servicecompany*/
  },
  dynamicBenefitsCalculation: true,
  dashboardLayout: 'b',
  routingBasePath: 'account',
  routingLoginRedirect: 'dashboard-dynamic', //'marketplace',
  googleErrorHandlerConfig: {
    apiKey: 'AIzaSyCxFBoA_w3OYf_mc7eBQD-MIT__uXCW0ZE',
    projectId: 'delfi-403115',
    scriptVersion: '0.12.0',
    sendConfiguration: {
      disabled: false,
      reportUncaughtExceptions: true,
      reportUnhandledPromiseRejections: true,
      service: 'mare',
      version: '15.0.0'
    }
  },
  menuConfig: {
    slugs: 'angular_platform,user_menu',
    useStaticMenu: false
  },
  cartConfig: {
    useLocalCart: false,
    useLocalCartPage: true,
    useRemoteCart: true,
    persistCart: false
  },
  // oauthIssuer: 'https://accounts.maredigital.it/realms/SC_USERS',
  // oauthIssuer: 'http://10.1.100.108:8083/realms/SC_USERS',
  oauthIssuer: 'https://accounts.maredigital.it/realms/SC_USERS',
  oauthConfig: {
    oauthIssuer: 'https://accounts.maredigital.it/realms/SC_USERS',
    oauthClientId: 'web',
    oauthResponseType: 'code',
    scope: 'profile email offline_access',
    disableAtHashCheck: true,
    showDebugInformation: true,
    checkOrigin: false,
    documentConfig: {

      loginUrl: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/auth",
      logoutUrl: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/logout",
      userinfoEndpoint: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/userinfo",
      tokenEndpoint: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/token",
      jwks: {
        "keys": [
          {
            "kid": "uVehTZzU-55XcSsCi-3HHNv3UIUHWPXUbGNxIMQh03M",
            "kty": "RSA",
            "alg": "RS256",
            "use": "sig",
            "n": "uIT56RDhiRflLQEf6dmr3PWR_zSrulnjObEbIcxHDR-jjQJXV3RnRgOHFFQ09KxXlnz9F2CipiNu_hxS6Uh0Mc7l3AXD4LM9bQnQdtDLkdCHtl1n5aT57wbwCdO919lZuV5BI39P7BeLrn_1spU_5fOJF1f9l6xi84aKrSWK_6QMtEpbiz3gUiubb8FUndZYA8y-VXyufKP8mLTO4zHX7h8ooA0e_5qBGxEq4MK9aBIc8IHKGjlikZNfHBh-FvQLzRN2qalEUGFdqMDI1SFtpuXk4_wpI8Ub0sPWRwRSYXlXWo8h46OYofaoaJweRl9sEqlIglZ6wNsN4f4NaGAqpw",
            "e": "AQAB",
            "x5c": [
              "MIICnzCCAYcCBgGDDLafczANBgkqhkiG9w0BAQsFADATMREwDwYDVQQDDAhTQ19VU0VSUzAeFw0yMjA5MDUwODEyMThaFw0zMjA5MDUwODEzNThaMBMxETAPBgNVBAMMCFNDX1VTRVJTMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuIT56RDhiRflLQEf6dmr3PWR/zSrulnjObEbIcxHDR+jjQJXV3RnRgOHFFQ09KxXlnz9F2CipiNu/hxS6Uh0Mc7l3AXD4LM9bQnQdtDLkdCHtl1n5aT57wbwCdO919lZuV5BI39P7BeLrn/1spU/5fOJF1f9l6xi84aKrSWK/6QMtEpbiz3gUiubb8FUndZYA8y+VXyufKP8mLTO4zHX7h8ooA0e/5qBGxEq4MK9aBIc8IHKGjlikZNfHBh+FvQLzRN2qalEUGFdqMDI1SFtpuXk4/wpI8Ub0sPWRwRSYXlXWo8h46OYofaoaJweRl9sEqlIglZ6wNsN4f4NaGAqpwIDAQABMA0GCSqGSIb3DQEBCwUAA4IBAQBaftGkoiQuPAwEUZPuMleXRwB/WVSWFYdP2ilRhssv8bDlIuSfok4c1iYglAPqTPi2Mip6BuOCAsdwCEhD5X/+arrl9qcvxPG024oXHNBxghAZBveYeShvQHl+DrO6zrY9u59zWRa6KZG7S/o+w0dlLe3UIfoOMvYukXVCOpvWo9r3CQWJxw3H70tGxNeRwRyz4NydSN244fbcr2PYqr8pCUVp0yDnJ62s7i5tw6mFVZ/3YgI/NuHNS0+/g3tFJWTqhTp1VC6EdSCXVLcMaqDB1o+VesiYCiaYpU9kfqFe5YTldrptyL2aFVzxeapCwO65LofYoPJrVQgz8Zj6Rl1t"
            ],
            "x5t": "4SEog1ifC5iPqtVQ-85DOYUTyqI",
            "x5t#S256": "iDBcQgbp8RkuapzX3T7Fjl05ZG1ZBqWFEM2Po6nIUsg"
          },
          {
            "kid": "116PZl0lJD37AwEnnB1rarqwRpW_1RCOZjYQ7SjlwaY",
            "kty": "RSA",
            "alg": "RSA-OAEP",
            "use": "enc",
            "n": "wFl5G1I5enPU8ceKdSGg87JBnWFUJjr5HBkq7DA5yLg8IqGHtlY-YWDRVZSqr_Ifl3sEz7Sj3Hj-qD7Lb2824XAvGmHXUZ6WJp7aj9SACG85GKPNL03CaElC94bvBzcW2rBfz5qsp1ssSkBooVVdAbwJObBfeVLZSLR6EUqxj-_dVXjxBYIZUlMgVQYq7BgentNjviJiP0ZYTX_XuRDhFOEIES15ffOgo6JzE9rKZR00s-wb4fh_WpbwZzLGiaXg2vIrbKp4WptrD7ehkS7wV2eJEXQnbWc5byXYU9bvfSDPHAVOcOnNz2Ce0G3mdGLaPeeQstPRlZ8mt-zAileTjw",
            "e": "AQAB",
            "x5c": [
              "MIICnzCCAYcCBgGDDLakvzANBgkqhkiG9w0BAQsFADATMREwDwYDVQQDDAhTQ19VU0VSUzAeFw0yMjA5MDUwODEyMTlaFw0zMjA5MDUwODEzNTlaMBMxETAPBgNVBAMMCFNDX1VTRVJTMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwFl5G1I5enPU8ceKdSGg87JBnWFUJjr5HBkq7DA5yLg8IqGHtlY+YWDRVZSqr/Ifl3sEz7Sj3Hj+qD7Lb2824XAvGmHXUZ6WJp7aj9SACG85GKPNL03CaElC94bvBzcW2rBfz5qsp1ssSkBooVVdAbwJObBfeVLZSLR6EUqxj+/dVXjxBYIZUlMgVQYq7BgentNjviJiP0ZYTX/XuRDhFOEIES15ffOgo6JzE9rKZR00s+wb4fh/WpbwZzLGiaXg2vIrbKp4WptrD7ehkS7wV2eJEXQnbWc5byXYU9bvfSDPHAVOcOnNz2Ce0G3mdGLaPeeQstPRlZ8mt+zAileTjwIDAQABMA0GCSqGSIb3DQEBCwUAA4IBAQASEeVdnezpzYeKVkSXIs8pkk9UYb0TLFctdtuEg6LKfiRmhZSjeEYWVahVB0lu2E592nY3ybuNHbu6XAhCgJdOz9QNbOWT0lE3e6VoTtHDFqdgNn5Twg5xTru6PPFMueKYqT5UTvsbDUIPCWZy1y++V2nU8rh5oqECFlLQvxquIFkLmQ5yTAa0ZLC3zeCuVCy5gI1UZ7hmCuCpfEW81uwyZ9h7y1Jy7tFObeF2Ef1nXCau2G+4L7ahkoMHQBsFMeOC+CqbxGuVwGAG3EnbMe5WseEzGGRH2wAIT0cMCdP+Fz5qMz/7KtYF9rcOzy3qGOIPrGSBUAgvuS4eYD1AXdeD"
            ],
            "x5t": "BHcsXYhugoPcw_iQbi76eRldI5M",
            "x5t#S256": "7zzwIHD5YdCk_26vbR_Rhct2wNBEa1JAar900t4TM5Y"
          }
        ]
      },
      sessionCheckIFrameUrl: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/login-status-iframe.html",
      revocationEndpoint: "https://accounts.maredigital.it/realms/SC_USERS/protocol/openid-connect/revoke"
    }
   },
  solveupStaticToken: 'B2B_296762a5-1ece-4a79-b51c-12e9d9f688c9',
  recaptchaSiteKey: '6LduNgIgAAAAAHof_ne8DYBSuBeQyeFOoAqZsO3L',
  solveupQuestionnaireId: 'UUID-QSTN-780c897e-eee3-4789-b8c1-0414e07dbd08',

  // BASE_NOMINATIM_URL: 'https://nominatim.openstreetmap.org',
  BASE_NOMINATIM_URL: 'https://marker.maredigital.it/dmj/nominatim',
  DEFAULT_VIEW_BOX: 'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000', //viewbox set the research to europe continent

  disallowAdminAccess: true,
  adminUrl: '/wp-admin',
  adminRoles: [ 'msc_administrator_role', 'msc_operator_role', 'msc_intermediator_role'],
  benchmarkSkus:['report-digitale','report-digitale-mini','report-digitale-medium'],
  unauthorizedRedirect: '/account/login',
  disableNotifyLostRequestestInWorkingTime: false,//activate to send notification through wp in working time
  maxElaborationTimeInHours: 1,
  workingtime: {
    dayStart: 1,
    dayEnd: 5,
    hourStart: 9,
    hourEnd: 18
  },
  logoutRedirectPath: '/logout',
  googleAnalyticsConfig: {
    isEnabled: false,
    siteId: 'GTM-5F5TGSH',
    // anonymizeIp: true,
    // gtag_id: 'G-WKQQ49X859'
  }
}

/*
* In development mode, to ignore zone related error stack frames such as
* `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
* import the following file, but please comment it out in production mode
* because it will have performance impact when throw error
*/
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
